var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpcoming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12.774h32.973v30.94c0 1.198-.76 2.168-1.7 2.168H12.7c-.938 0-1.699-.97-1.699-2.168V14.666c0-1.045.895-1.892 2-1.892z",
    fill: "#fff",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.699 12.565h31.575c.938 0 1.699.725 1.699 1.618v6.989H11v-6.989c0-.893.76-1.618 1.699-1.618z",
    fill: "#8B8B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.172h34.973v3.783H11v-3.783z",
    fill: "#FAA918",
    stroke: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M11 20.146h34.973v1.026H11z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.879,
    y: 11,
    width: 2.136,
    height: 4.959,
    rx: 1.068,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.227,
    y: 11,
    width: 2.136,
    height: 4.959,
    rx: 1.068,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 28.5,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.625,
    y: 28.5,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.875,
    y: 28.5,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 28.5,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 33.75,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.625,
    y: 33.75,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 33.75,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32.875,
    y: 33.75,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 33.75,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#FAA918"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 39,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20.625,
    y: 39,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 39,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 32.875,
    y: 39,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.d82411057c8769a3c9eccbf6d8f70762.svg";
export { ForwardRef as ReactComponent };